import { allegato_all, thread_all, shortlist_all } from '../reducers';

import { refresh_cache } from 'django-rest-react';

export const refresh_allegato = () => refresh_cache(allegato_all);
export const refresh_thread_problema_list = () => refresh_cache(thread_all);
export const refresh_shortlist = () => refresh_cache(shortlist_all);
